import React from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Invoice } from 'shared';

interface PDFPreviewDialogProps {
  visible: boolean;
  invoice: Invoice | null;
  previewURL: string | null;
  onHide: () => void;
}

export const PDFPreviewDialog: React.FC<PDFPreviewDialogProps> = ({
  visible,
  invoice,
  previewURL,
  onHide,
}) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={invoice ? `Invoice ${invoice.invoiceNumber}` : 'Invoice Preview'}
      style={{ width: '90vw', height: '90vh' }}
      maximizable
      modal
    >
      <div data-component="pdf-preview-dialog" style={{ width: '100%', height: 'calc(90vh - 120px)' }}>
        {previewURL ? (
          <iframe
            src={previewURL}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="Invoice PDF Preview"
          />
        ) : (
          <div className="flex align-items-center justify-content-center" style={{ height: '100%' }}>
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};
